module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-section payment-page",
    class: [_vm.paymentMethod]
  }, [_c('h1', {
    staticClass: "page-title text-center"
  }, [_vm._v("ชำระเงิน")]), _vm._v(" "), _c('div', {
    ref: "termsModal",
    staticClass: "modal",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideTermsModal
    }
  }, [_vm._v("ปิด")])])])])]), _vm._v(" "), _c('donate-step-bar', {
    on: {
      "clickstep": _vm.onStep
    }
  }), _vm._v(" "), (!_vm.$utils.isCartEmpty()) ? _c('div', {
    staticClass: "container pd-sm-0 mt-3"
  }, [(false) ? _c('payment-summary', {
    staticClass: "show-sm"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "with-sidebar"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "sidebar block-border block radius show-sm mb-3"
  }, _vm._l((_vm.$store.state.cart), function(cart) {
    return _c('div', {
      staticClass: "summary__row--lg"
    }, [_c('div', {
      staticClass: "title mb-2 mb-md-3"
    }, [_vm._v(_vm._s(_vm.$store.state.donateType === 'monthly' ? 'บริจาครายเดือนให้กับ' : 'บริจาคให้กับ'))]), _vm._v(" "), _c('div', {
      staticClass: "summary__label"
    }, [_vm._v(_vm._s(cart.product.name))]), _vm._v(" "), _c('div', {
      staticClass: "summary__value"
    }, [_vm._v(_vm._s(_vm._f("comma")(cart.product.price)) + " "), _c('span', {
      staticClass: "txt-normal"
    }, [_vm._v("บาท")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "block-primary block radius b-email mb-4"
  }, [_c('h2', {
    staticClass: "block__title"
  }, [_vm._v("ข้อมูลยืนยันการบริจาค")]), _vm._v(" "), _c('div', {
    staticClass: "form__item--block"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("อีเมล")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form__text",
    class: {
      'form__input--error': _vm.$v.isError('email')
    },
    attrs: {
      "type": "text",
      "name": "email",
      "id": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.email.empty),
      expression: "$v.$errors.email.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกอีเมล")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.email.invalid),
      expression: "$v.$errors.email.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกอีเมลให้ถูกต้อง")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.email.facebookEmail),
      expression: "$v.$errors.email.facebookEmail"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกอีเมลที่ใช้ได้จริง ไม่อนุญาตให้ใช้อีเมลของ Facebook")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "form__item--block"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("เบอร์ติดต่อ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form__text",
    class: {
      'form__input--error': _vm.$v.isError('phone')
    },
    attrs: {
      "type": "text",
      "name": "phone",
      "id": "phone",
      "required": "",
      "pattern": "[0-9\\-\\+]*"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.phone.empty),
      expression: "$v.$errors.phone.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกเบอร์ติดต่อ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.$errors.phone.empty && _vm.$v.$errors.phone.invalid),
      expression: "!$v.$errors.phone.empty && $v.$errors.phone.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกเบอร์ติดต่อให้ถูกต้อง")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-primary block radius"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('h2', {
    staticClass: "block__title"
  }, [_vm._v("ช่องทางการบริจาค")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.paymentMethod.empty),
      expression: "$v.$errors.paymentMethod.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกวิธีการบริจาค")]), _vm._v(" "), _c('div', {
    staticClass: "form__wrapper"
  }, [(_vm.isPaymentMethodEnable('thaiqr')) ? _c('div', {
    staticClass: "form__section",
    on: {
      "click": function($event) {
        _vm.paymentMethod = 'thaiqr';
        _vm.taxInfoTab = 'person'
      }
    }
  }, [_c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentMethod),
      expression: "paymentMethod"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "payment_method",
      "id": "thaiqr",
      "value": "thaiqr"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentMethod, "thaiqr")
    },
    on: {
      "change": function($event) {
        _vm.paymentMethod = "thaiqr"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label form__label--title",
    attrs: {
      "for": "thaiqr"
    }
  }, [_vm._v("QR Code ผ่าน Mobile Banking App")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), (_vm.isPaymentMethodEnable('thaiqr')) ? _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isThaiQR),
      expression: "isThaiQR"
    }],
    staticClass: "slide-down-wrapper"
  }, [_c('div', {
    staticClass: "block-third slide-down-item"
  }, [_c('div', {
    staticClass: "form__item--inline"
  }, [_c('div', [_c('ul', {
    staticClass: "text-muted-ss"
  }, [_c('li', [_vm._v("ชำระผ่านการสแกน QR code ด้วย Mobile Banking Application ของธนาคารที่กำหนด")]), _vm._v(" "), _c('li', [_vm._v("ผู้บริจาคจะได้ QR Code หลังจากกดปุ่มยืนยันการบริจาค")]), _vm._v(" "), _c('li', [_vm._v("การบริจาคผ่าน QR Code ในโครงการ e-Donation ข้อมูลการบริจาคของคุณจะถูกส่งไปกรมสรรพากรเพื่อลดหย่อนภาษีโดยอัตโนมัติ")]), _vm._v(" "), _c('li', [_vm._v("ท่านสามารถตรวจสอบรายการบริจาคในระบบกรมสรรพากรหลังจากบริจาคแล้ว 3-7 วัน "), _c('a', {
    attrs: {
      "href": "https://epayapp.rd.go.th/rd-edonation/portal/for-donor",
      "target": "_blank"
    }
  }, [_vm._v("ได้ที่นี่")])])])])])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isPaymentMethodEnable('bank_transfer')) ? _c('div', {
    staticClass: "form__section",
    on: {
      "click": function($event) {
        _vm.paymentMethod = 'bank_transfer'
      }
    }
  }, [_c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentMethod),
      expression: "paymentMethod"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "payment_method",
      "id": "tranfer",
      "value": "bank_transfer"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentMethod, "bank_transfer")
    },
    on: {
      "change": function($event) {
        _vm.paymentMethod = "bank_transfer"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label form__label--title",
    attrs: {
      "for": "tranfer"
    }
  }, [_vm._v("โอนเงินผ่านบัญชีธนาคาร")]), _vm._v(" "), _c('span', {
    staticClass: "block--icon-bank"
  }, _vm._l((_vm.$config.BANK_TRANSFER), function(bank) {
    return _c('span', {
      staticClass: "block__img__wrapper"
    }, [(bank[0] == 'promptpay') ? _c('img', {
      attrs: {
        "src": require("../assets/img/icon/promptpay.jpg"),
        "height": "25",
        "alt": bank[1]
      }
    }) : _c('img', {
      class: 'block__img block__img--' + bank[0],
      attrs: {
        "src": _vm.$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg')),
        "width": "25",
        "height": "25",
        "alt": bank[1]
      }
    })])
  }), 0)]), _vm._v(" "), (_vm.isPaymentMethodEnable('bank_transfer')) ? _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTransfer),
      expression: "isTransfer"
    }],
    staticClass: "slide-down-wrapper"
  }, [_c('div', {
    staticClass: "block-third slide-down-item"
  }, [_c('div', {
    staticClass: "form__item--inline"
  }, [_vm._l((_vm.$config.BANK_TRANSFER), function(bank) {
    return _c('div', {
      staticClass: "block--transfer border p-2 rounded"
    }, [(bank[0] == 'promptpay') ? _c('div', {
      staticClass: "block__flex promptpay__wrapper"
    }, [_c('img', {
      staticClass: "ic-promptpay",
      attrs: {
        "src": require("../assets/img/icon/promptpay.jpg"),
        "height": "40",
        "alt": bank[1]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "promptpay--detail"
    }, [_vm._v(_vm._s(bank[1]) + " ชื่อบัญชี: " + _vm._s(bank[2])), _c('br'), _vm._v("รหัส " + _vm._s(bank[3]) + " (เลขประจำตัวผู้เสียภาษี)")])]) : _c('div', {
      staticClass: "block__flex"
    }, [_c('div', [_vm._v(_vm._s(bank[1]) + " ชื่อบัญชี: " + _vm._s(bank[2])), _c('br'), _vm._v("เลขบัญชี " + _vm._s(bank[3]))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "block__flex"
  }, [_c('i', {
    staticClass: "alert__icon icon-info"
  }), _vm._v(" "), _c('div', {
    staticClass: "alert__text"
  }, [_vm._v("เมื่อชำระเงินเรียบร้อยแล้ว สามารถยืนยันการโอนเงินจากแบบฟอร์มในขั้นตอนถัดไป หรือจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "block text-muted pd-15 font-sm"
  }, [_c('ul', {
    staticClass: "ma-0"
  }, [_c('li', [_vm._v("เตรียมหลักฐานการโอนเงินเป็นรูปภาพหรือรูปถ่าย เช่น รูปถ่ายใบเสร็จการโอนเงินจากตู้ ATM หรือรูปภาพหน้าจอในกรณีที่ทำธุรกรรมออนไลน์")]), _vm._v(" "), _c('li', [_vm._v("ไม่มีค่าธรรมเนียมการโอน")]), _vm._v(" "), _c('li', [_vm._v("ผู้บริจาคต้องแนบหลักฐานการโอนเงินภายใน 3 วันหลังจากทำรายการสำเร็จ")])])])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isPaymentMethodEnable('credit_card')) ? _c('div', {
    staticClass: "form__section"
  }, [_c('div', {
    staticClass: "form__item form__item--inline",
    on: {
      "click": function($event) {
        _vm.paymentMethod = 'credit_card'
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentMethod),
      expression: "paymentMethod"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "id": "creditcard",
      "name": "payment_method",
      "value": "credit_card"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentMethod, "credit_card")
    },
    on: {
      "change": function($event) {
        _vm.paymentMethod = "credit_card"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label form__label--title",
    attrs: {
      "for": "creditcard"
    }
  }, [_vm._v("Credit Card / Debit Card")]), _vm._v(" "), _c('div', {
    staticClass: "block--icon-bank"
  }, [_c('img', {
    attrs: {
      "src": _vm.$utils.svg(require('../assets/img/ic-visa.svg')),
      "alt": "Visa",
      "height": "18"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.$utils.svg(require('../assets/img/ic-mastercard.svg')),
      "alt": "Master Card",
      "height": "20"
    }
  })])]), _vm._v(" "), (_vm.isPaymentMethodEnable('credit_card')) ? _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCreditCard),
      expression: "isCreditCard"
    }],
    staticClass: "slide-down-wrapper"
  }, [_c('div', {
    staticClass: "block-third slide-down-item"
  }, [_c('div', {
    staticClass: "mt-15 text-left"
  }, [_c('ul', {
    staticClass: "text-muted-ss"
  }, [_c('li', [_vm._v("ชำระเงินผ่านบัตรเครดิต / บัตรเดบิต VISA, Master Card")]), _vm._v(" "), _c('li', [_vm._v("ข้อมูลบัตรจะถูกดำเนินการอย่างปลอดภัยด้วยผู้ให้บริการที่ผ่านมาตรฐาน")])])])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (false) ? _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCreditCard),
      expression: "isCreditCard"
    }],
    staticClass: "slide-down-wrapper"
  }, [_c('div', {
    staticClass: "form__section block-third slide-down-item"
  }, [_c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "id-creditcard"
    }
  }, [_vm._v("หมายเลขบัตร 16 หลัก")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ccNumber),
      expression: "ccNumber"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('ccNumber')
    },
    attrs: {
      "type": "text",
      "name": "id-creditcard",
      "id": "id-creditcard",
      "required": _vm.useCreditCard,
      "autocomplete": "new-password",
      "readonly": !_vm.formReady
    },
    domProps: {
      "value": (_vm.ccNumber)
    },
    on: {
      "keydown": _vm.validateCreditCardKey,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ccNumber = $event.target.value
      }, _vm.updateCreditCardValue]
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.ccNumber.empty),
      expression: "$v.$errors.ccNumber.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกหมายเลขบัตร")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.ccNumber.invalid),
      expression: "$v.$errors.ccNumber.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกหมายเลขบัตรให้ถูกต้อง")]), _vm._v(" "), _c('i', {
    staticClass: "lock__icon icon-lock"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "name-creditcard"
    }
  }, [_vm._v("ชื่อผู้ถือบัตร")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ccHolderName),
      expression: "ccHolderName"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('ccHolderName')
    },
    attrs: {
      "type": "text",
      "value": "",
      "name": "name-creditcard",
      "id": "name-creditcard",
      "required": _vm.useCreditCard,
      "readonly": !_vm.formReady
    },
    domProps: {
      "value": (_vm.ccHolderName)
    },
    on: {
      "keydown": _vm.validateCreditCardHolderKey,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ccHolderName = $event.target.value
      }, _vm.updateCreditCardHolder]
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.ccHolderName.empty),
      expression: "$v.$errors.ccHolderName.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกชื่อผู้ถือบัตร")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "expired"
    }
  }, [_vm._v("MM/YY")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ccExpired),
      expression: "ccExpired"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('ccExpired')
    },
    attrs: {
      "type": "text",
      "value": "",
      "name": "expired",
      "id": "expired",
      "required": _vm.useCreditCard,
      "pattern": "[0-9]{2}/[0-9]{2}",
      "readonly": !_vm.formReady
    },
    domProps: {
      "value": (_vm.ccExpired)
    },
    on: {
      "keydown": _vm.validateExpiredKey,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ccExpired = $event.target.value
      }, function($event) {
        return _vm.updateExpiredValue($event.target.value)
      }]
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.ccExpired.empty),
      expression: "$v.$errors.ccExpired.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกเดือน/ปีที่หมดอายุ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.ccExpired.invalid),
      expression: "$v.$errors.ccExpired.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกเดือน/ปีให้ถูกต้อง")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item--securitycode w-30"
  }, [_c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "cvv"
    }
  }, [_vm._v("CVV")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ccCVV),
      expression: "ccCVV"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('ccCVV')
    },
    attrs: {
      "type": "password",
      "value": "",
      "name": "cvv",
      "id": "cvv",
      "required": _vm.useCreditCard,
      "autocomplete": "new-password",
      "readonly": !_vm.formReady
    },
    domProps: {
      "value": (_vm.ccCVV)
    },
    on: {
      "keydown": _vm.validateCVVKey,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ccCVV = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.ccCVV.empty),
      expression: "$v.$errors.ccCVV.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกรหัสหลังบัตร 3 หลัก")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.ccCVV.invalid),
      expression: "$v.$errors.ccCVV.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกรหัสหลังบัตรให้ถูกต้อง")])]), _vm._v(" "), _c('a', {
    staticClass: "tooltips"
  }, [_c('i', {
    staticClass: "icon-help"
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v("รหัสความปลอดภัยหลังบัตร 3 หลัก")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-15 text-center"
  }, [_c('ul', {
    staticClass: "text-muted-ss"
  }, [_c('li', [_vm._v("ชำระเงินผ่านบัตรเครดิต / บัตรเดบิต VISA, Master Card,")]), _vm._v(" "), _c('li', [_vm._v("ข้อมูลบัตรจะถูกดำเนินการอย่างปลอดภัยด้วยผู้ให้บริการที่ผ่านมาตรฐาน")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isPaymentMethodEnable('line_pay')) ? _c('div', {
    staticClass: "form__section",
    on: {
      "click": function($event) {
        _vm.paymentMethod = 'line_pay'
      }
    }
  }, [_c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentMethod),
      expression: "paymentMethod"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "payment_method",
      "id": "line_pay",
      "value": "line_pay"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentMethod, "line_pay")
    },
    on: {
      "change": function($event) {
        _vm.paymentMethod = "line_pay"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label form__label--title",
    attrs: {
      "for": "line_pay"
    }
  }, [_vm._v("Rabbit LINE Pay")]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), (_vm.isPaymentMethodEnable('line_pay')) ? _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLinePay),
      expression: "isLinePay"
    }],
    staticClass: "slide-down-wrapper"
  }, [_c('div', {
    staticClass: "block-third slide-down-item"
  }, [_c('div', {
    staticClass: "form__item--inline"
  }, [_c('div', [_c('ul', {
    staticClass: "text-muted-ss"
  }, [_c('li', [_vm._v("สามารถชำระเงินด้วยบัตรเดบิต / เครดิต หรือช่องทางอื่นๆ ของ Rabbit LINE Pay ได้ ")]), _vm._v(" "), _c('li', [_vm._v("Rabbit LINE Pay พร้อมให้บริการใน LINE App ตั้งแต่เวอร์ชั่น 4.8.0 ใน iPhone และ ตั้งแต่เวอร์ชั่น 5.4.1 ใน Android")])])])])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isPaymentMethodEnable('internet_banking')) ? _c('div', {
    staticClass: "form__section",
    on: {
      "click": function($event) {
        _vm.paymentMethod = 'internet_banking'
      }
    }
  }, [_c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentMethod),
      expression: "paymentMethod"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "payment_method",
      "id": "internet_banking",
      "value": "internet_banking"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentMethod, "internet_banking")
    },
    on: {
      "change": function($event) {
        _vm.paymentMethod = "internet_banking"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label form__label--title",
    attrs: {
      "for": "internet_banking"
    }
  }, [_vm._v("Internet Banking")]), _vm._v(" "), _c('span', {
    staticClass: "block--icon-bank"
  }, _vm._l((_vm.$config.OMISE_INTERNET_BANKING), function(bank) {
    return _c('img', {
      class: 'block__img block__img--' + bank[0],
      attrs: {
        "src": _vm.$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg')),
        "width": "25",
        "height": "25",
        "alt": bank[1]
      }
    })
  }), 0)]), _vm._v(" "), (_vm.isPaymentMethodEnable('internet_banking')) ? _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInternetBanking),
      expression: "isInternetBanking"
    }],
    staticClass: "slide-down-wrapper"
  }, [_c('div', {
    staticClass: "block-third slide-down-item"
  }, [_c('div', {
    staticClass: "form__item--inline"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.internetBankingOffsite.empty),
      expression: "$v.$errors.internetBankingOffsite.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกธนาคาร")]), _vm._v(" "), _vm._l((_vm.$config.OMISE_INTERNET_BANKING), function(bank) {
    return _c('div', {
      staticClass: "block__flex block--internet_banking"
    }, [_c('div', {
      staticClass: "radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.internetBankingOffsite),
        expression: "internetBankingOffsite"
      }],
      attrs: {
        "type": "radio",
        "name": "offsite",
        "id": ("offsite_" + (bank[0])),
        "required": _vm.isInternetBanking
      },
      domProps: {
        "value": ("internet_banking_" + (bank[0])),
        "checked": _vm._q(_vm.internetBankingOffsite, ("internet_banking_" + (bank[0])))
      },
      on: {
        "change": function($event) {
          _vm.internetBankingOffsite = "internet_banking_" + (bank[0])
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("offsite_" + (bank[0]))
      }
    }, [_c('img', {
      class: 'block__img block__img--' + bank[0],
      attrs: {
        "src": _vm.$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg')),
        "width": "40",
        "alt": bank[1]
      }
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(bank[1]))])])])])
  })], 2)])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isPaymentMethodEnable('2c2p:123')) ? _c('div', {
    staticClass: "form__section",
    on: {
      "click": function($event) {
        _vm.paymentMethod = '2c2p:123'
      }
    }
  }, [_c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentMethod),
      expression: "paymentMethod"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "payment_method",
      "id": "2c2p_123",
      "value": "2c2p:123"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentMethod, "2c2p:123")
    },
    on: {
      "change": function($event) {
        _vm.paymentMethod = "2c2p:123"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label form__label--title",
    attrs: {
      "for": "internet_banking"
    }
  }, [_vm._v("Internet banking / Counter / ATM")]), _vm._v(" "), _c('span', {
    staticClass: "block--icon-bank"
  }, _vm._l((_vm.$config.OMISE_INTERNET_BANKING), function(bank) {
    return _c('span', {
      staticClass: "block__img__wrapper"
    }, [_c('img', {
      class: 'block__img block__img--' + bank[0],
      attrs: {
        "src": _vm.$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg')),
        "width": "25",
        "height": "25",
        "alt": bank[1]
      }
    })])
  }), 0), _vm._v(" "), _vm._m(5)]), _vm._v(" "), (_vm.isPaymentMethodEnable('2c2p:123')) ? _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is2C2P123),
      expression: "is2C2P123"
    }],
    staticClass: "slide-down-wrapper"
  }, [_c('div', {
    staticClass: "block-third slide-down-item"
  }, [_c('div', {
    staticClass: "form__item--inline"
  }, [_c('div', [_c('ul', {
    staticClass: "text-muted-ss"
  }, [_c('li', [_vm._v("สามารถชำระเงินผ่านบริการออนไลน์ของธนาคารได้ดังนี้ ธนาคารไทยพาณิชย์, ธนาคารกรุงไทย, ธนาคารทหารไทย, ​ธนาคารยูโอบี,​ ธนาคารกรุงศรีอยุธยา,​ ธนาคารกรุงเทพ,  ธนาคารกสิกรไทย และธนาคารธนชาติ​")]), _vm._v(" "), _c('li', [_vm._v("สามารถชำระเงินผ่านเคาน์เตอร์ของตัวแทนได้ดังนี้ Tesco Lotus, Big C, Pay@Post, MPAY, TrueMoney, CENPAY และตู้บุญเติม")]), _vm._v(" "), _c('li', [_vm._v("อาจมีค่าบริการ 5-15 บาทต่อครั้ง ขึ้นอยู่กับผู้บริการ")])])])])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isPaymentMethodEnable('cheque')) ? _c('div', {
    staticClass: "form__section",
    on: {
      "click": function($event) {
        _vm.paymentMethod = 'cheque'
      }
    }
  }, [_c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('input', {
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "payment_method",
      "id": "cheque",
      "value": "cheque"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label form__label--title",
    attrs: {
      "for": "cheque"
    }
  }, [_vm._v("เช็คสั่งจ่าย")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "form__label--note"
  }, [_vm._v("มูลนิธิยุวพัฒน์ เพื่อโครงการร้อยพลังการศึกษา")]), _vm._v(" "), _c('span', {
    staticClass: "block--icon-bank"
  }, [_c('img', {
    attrs: {
      "src": _vm.$utils.svg(require('../assets/img/ic-cheque.svg')),
      "alt": "เช็คสั่งจ่าย"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.isPaymentMethodEnable('paypal')) ? _c('div', {
    staticClass: "form__section",
    on: {
      "click": function($event) {
        _vm.paymentMethod = 'paypal'
      }
    }
  }, [_c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentMethod),
      expression: "paymentMethod"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "radio",
      "name": "payment_method",
      "id": "paypal",
      "value": "paypal"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentMethod, "paypal")
    },
    on: {
      "change": function($event) {
        _vm.paymentMethod = "paypal"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label form__label--title",
    attrs: {
      "for": "paypal"
    }
  }, [_vm._v("PayPal")]), _vm._v(" "), _c('img', {
    staticClass: "fl-right",
    attrs: {
      "src": _vm.$utils.svg(require('../assets/img/ic-paypal.svg')),
      "alt": "PayPal"
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "block-primary block fixed fixed--bottom show-sm"
  }, [_c('div', {}, [_c('div', {
    staticClass: "form__item--inline mb-15 text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptPolicy),
      expression: "acceptPolicy"
    }],
    staticClass: "form__text",
    attrs: {
      "type": "checkbox",
      "name": "terms",
      "id": "terms1"
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptPolicy) ? _vm._i(_vm.acceptPolicy, null) > -1 : (_vm.acceptPolicy)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.acceptPolicy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.acceptPolicy = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.acceptPolicy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptPolicy = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label text-dark -font-light",
    attrs: {
      "for": "terms1"
    }
  }, [_vm._v("ฉันได้อ่านและยอมรับ "), _c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('terms'),
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showTermsModal($event)
      }
    }
  }, [_c('u', [_vm._v("ข้อตกลงและเงื่อนไข")])])])])]), _vm._v(" "), (!_vm.isPaypal) ? _c('button', {
    staticClass: "btn btn--purple ma-0 btn-confirm",
    attrs: {
      "disabled": !_vm.acceptPolicy
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("ยืนยันการบริจาค")]) : _vm._e(), _vm._v(" "), (_vm.isPaypal) ? _c('paypal-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paypalButtonReady),
      expression: "paypalButtonReady"
    }],
    ref: "paypalButton1",
    attrs: {
      "id": "paypal-button",
      "payment": _vm.paypalPayment,
      "onAuthorize": _vm.paypalOnAuthorize,
      "onCancel": _vm.paypalOnCancel
    },
    on: {
      "ready": function($event) {
        _vm.paypalButtonReady = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPaypal) ? _c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.paypalButtonReady),
      expression: "!paypalButtonReady"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.isTransfer) ? _c('div', {
    staticClass: "mt-3 text-muted-ss text-center"
  }, [_vm._v("หลังจากโอนเงินแล้ว กรุณายืนยันการโอนเงินจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "block-primary block radius b-payment mt-3"
  }, [_c('h2', {
    staticClass: "block__title mb-0"
  }, [_vm._v("ใบเสร็จรับเงิน")]), _vm._v(" "), (_vm.paymentMethod != 'thaiqr') ? [_c('div', {
    staticClass: "fs-sm mb-15 mt-2 text-dark"
  }, [_vm._v("\n              ระบบจะจัดส่งใบเสร็จรับเงินเป็นไฟล์ PDF ทางอีเมลภายหลัง\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.taxInfoTab === 'person'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.taxInfoTab = 'person'
      }
    }
  }, [_vm._v("บุคคลธรรมดา")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.taxInfoTab === 'legalPerson'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.taxInfoTab = 'legalPerson'
      }
    }
  }, [_vm._v("นิติบุคคล")])])]), _vm._v(" "), _c('div', {
    staticClass: "border border-top-0 p-3 bg-white"
  }, [(_vm.taxInfoTab === 'person') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "form__item--block"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "fullname"
    }
  }, [_vm._v("ชื่อ-นามสกุล")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }],
    staticClass: "form__text",
    class: {
      'form__input--error': _vm.$v.isError('fullname')
    },
    attrs: {
      "type": "text",
      "name": "fullname",
      "id": "fullname"
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.fullname.empty),
      expression: "$v.$errors.fullname.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกข้อมูล")]), _vm._v(" "), _c('div', {
    staticClass: "fs-xs text-dark"
  }, [_vm._v("กรุณากรอกด้วยชื่อ-นามสกุลจริงตามบัตรประชาชนเพื่อสิทธิประโยชน์ในการลดหย่อนภาษี")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "form__item--block"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "taxid"
    }
  }, [_vm._v("เลขบัตรประชาชน")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taxId),
      expression: "taxId"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('#-####-#####-##-#'),
      expression: "'#-####-#####-##-#'"
    }],
    staticClass: "form__text",
    class: {
      'form__input--error': _vm.$v.isError('taxId')
    },
    attrs: {
      "type": "text",
      "name": "taxid",
      "id": "taxid",
      "maxlength": "17"
    },
    domProps: {
      "value": (_vm.taxId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taxId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.taxId.empty),
      expression: "$v.$errors.taxId.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกเลขบัตรประชาชนเพื่อสิทธิประโยชน์ในการลดหย่อนภาษี "), _c('span', {
    staticClass: "d-none"
  }, [_vm._v("กรุณากรอกข้อมูลเป็นตัวเลขเท่านั้น ไม่ต้องใส่เว้นวรรคหรือขีดกลาง")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.taxId.invalid),
      expression: "$v.$errors.taxId.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("เลขบัตรประชาชนต้องเป็นตัวเลข 13 หลัก"), _vm._m(6)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.taxId.taxIdFormatInvalid),
      expression: "$v.$errors.taxId.taxIdFormatInvalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("รูปแบบเลขบัตรประชาชนไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง")])])])]) : _vm._e(), _vm._v(" "), (_vm.taxInfoTab === 'legalPerson') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "form__item--block"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "fullname"
    }
  }, [_vm._v("ชื่อองค์กร")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }],
    staticClass: "form__text",
    class: {
      'form__input--error': _vm.$v.isError('fullname')
    },
    attrs: {
      "type": "text",
      "name": "fullname",
      "id": "fullname"
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.fullname.empty),
      expression: "$v.$errors.fullname.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกข้อมูล")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "form__item--block"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "taxid"
    }
  }, [_vm._v("เลขประจำตัวผู้เสียภาษี")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taxId),
      expression: "taxId"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('#-####-#####-##-#'),
      expression: "'#-####-#####-##-#'"
    }],
    staticClass: "form__text",
    class: {
      'form__input--error': _vm.$v.isError('taxId')
    },
    attrs: {
      "type": "text",
      "name": "taxid",
      "id": "taxid",
      "maxlength": "17"
    },
    domProps: {
      "value": (_vm.taxId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taxId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.taxId.empty),
      expression: "$v.$errors.taxId.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกเลขประจำตัวผู้เสียภาษีเพื่อสิทธิประโยชน์ในการลดหย่อนภาษี "), _c('span', {
    staticClass: "d-none"
  }, [_vm._v("ไม่ต้องใส่เว้นวรรคหรือขีดกลาง")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.taxId.invalid),
      expression: "$v.$errors.taxId.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("เลขประจำตัวผู้เสียภาษีต้องเป็นตัวเลข 13 หลัก"), _vm._m(7)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.taxId.taxIdFormatInvalid),
      expression: "$v.$errors.taxId.taxIdFormatInvalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("รูปแบบเลขประจำตัวผู้เสียภาษีไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form__item--block"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "taxAddress"
    }
  }, [_vm._v("ที่อยู่")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.receiptAddress),
      expression: "receiptAddress"
    }],
    staticClass: "form__textarea",
    attrs: {
      "id": "taxAddress"
    },
    domProps: {
      "value": (_vm.receiptAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.receiptAddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.receiptAddress.empty),
      expression: "$v.$errors.receiptAddress.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกข้อมูล")])])])]) : _vm._e()])] : [_c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n              * การบริจาคผ่าน QR code ในโครงการ e-Donation ชื่อ-นามสกุลบนใบเสร็จรับเงินจะเป็นชื่อเจ้าของบัญชี\n              Mobile banking และข้อมูลบนใบเสร็จรับเงินของคุณจะถูกจัดส่งไปที่กรมสรรพากรอัตโนมัติ\n            ")])]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-container hide-sm"
  }, [_c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        top: 10,
        triggerTop: 'auto',
        triggerBottom: 70,
        bottom: -90
      }),
      expression: "{top: 10, triggerTop: 'auto', triggerBottom: 70, bottom: -90}"
    }],
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "block-border radius"
  }, [_vm._l((_vm.$store.state.cart), function(cart) {
    return _c('div', {
      staticClass: "summary__row--lg"
    }, [_c('div', {
      staticClass: "sidebar__title small"
    }, [_vm._v(_vm._s(_vm.$store.state.donateType === 'monthly' ? 'บริจาครายเดือนให้กับ' : 'บริจาคให้กับ'))]), _vm._v(" "), _c('div', {
      staticClass: "summary__label"
    }, [_vm._v(_vm._s(cart.product.name))]), _vm._v(" "), _c('div', {
      staticClass: "summary__value"
    }, [_vm._v(_vm._s(_vm._f("comma")(cart.product.price)) + " "), _c('span', {
      staticClass: "txt-normal"
    }, [_vm._v("บาท")])])])
  }), _vm._v(" "), (_vm.$store.state.cart.length > 1) ? _c('div', {
    staticClass: "summary__row summary__row--lg"
  }, [_c('div', {
    staticClass: "summary__label"
  }), _vm._v(" "), _c('div', {
    staticClass: "summary__value"
  }, [_vm._v(_vm._s(_vm._f("comma")(_vm.$utils.getCartGrandTotalPrice())) + " ฿")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pt-15 block bg-gray border-bottom-radius"
  }, [_c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptPolicy),
      expression: "acceptPolicy"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "checkbox",
      "name": "terms",
      "id": "terms2"
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptPolicy) ? _vm._i(_vm.acceptPolicy, null) > -1 : (_vm.acceptPolicy)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.acceptPolicy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.acceptPolicy = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.acceptPolicy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptPolicy = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label text-dark",
    attrs: {
      "for": "terms2"
    }
  }, [_vm._v("ฉันได้อ่านและยอมรับ "), _c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('terms'),
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showTermsModal($event)
      }
    }
  }, [_c('u', [_vm._v("ข้อตกลงและเงื่อนไข")])])]), _vm._v(" "), _c('p', {
    staticClass: "text-muted-ss text-dark"
  }, [_vm._v("ข้อมูลเกี่ยวกับการชำระเงินจะถูกเก็บรักษาภายใต้ความปลอดภัยของระบบ")])]), _vm._v(" "), (!_vm.isPaypal) ? _c('button', {
    staticClass: "btn btn--purple ma-0 btn-confirm",
    attrs: {
      "disabled": !_vm.acceptPolicy
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("ยืนยันการบริจาค")]) : _vm._e(), _vm._v(" "), (_vm.isPaypal) ? _c('paypal-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paypalButtonReady),
      expression: "paypalButtonReady"
    }],
    ref: "paypalButton2",
    attrs: {
      "id": "paypal-button2",
      "payment": _vm.paypalPayment,
      "onAuthorize": _vm.paypalOnAuthorize,
      "onCancel": _vm.paypalOnCancel
    },
    on: {
      "ready": function($event) {
        _vm.paypalButtonReady = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPaypal) ? _c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.paypalButtonReady),
      expression: "!paypalButtonReady"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.isTransfer) ? _c('div', {
    staticClass: "text-muted text-center pd-15 mt-15"
  }, [_vm._v("หลังจากโอนเงินแล้ว กรุณายืนยันการโอนเงินจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้")]) : _vm._e()], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "sidebar sidebar-ghost"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.$utils.isCartEmpty()) ? _c('div', {
    staticClass: "container block-primary block shadow radius empty-cart"
  }, [_vm._v("\n    คุณยังไม่ได้เลือกรายการบริจาค\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'products_list'
      }
    }
  }, [_vm._v("เลือกดูรายการของเรา")])], 1) : _vm._e(), _vm._v(" "), _c('form', {
    ref: "form2c2p",
    attrs: {
      "action": _vm.form2c2p.paymentUrl,
      "method": "POST"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "version"
    },
    domProps: {
      "value": _vm.form2c2p.version
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "merchant_id"
    },
    domProps: {
      "value": _vm.form2c2p.merchant_id
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "payment_description"
    },
    domProps: {
      "value": _vm.form2c2p.payment_description
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "order_id"
    },
    domProps: {
      "value": _vm.form2c2p.order_id
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency"
    },
    domProps: {
      "value": _vm.form2c2p.currency
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "amount"
    },
    domProps: {
      "value": _vm.form2c2p.amount
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "result_url_1"
    },
    domProps: {
      "value": _vm.form2c2p.resultUrl
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "result_url_2"
    },
    domProps: {
      "value": _vm.form2c2p.backendReturnUrl
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "payment_option"
    },
    domProps: {
      "value": _vm.form2c2p.paymentOption
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "customer_email"
    },
    domProps: {
      "value": _vm.email
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "payment_expiry"
    },
    domProps: {
      "value": _vm.form2c2p.paymentExpiry
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "default_lang",
      "value": "th"
    }
  }), _vm._v(" "), (_vm.form2c2p.recurring == 'Y' || _vm.form2c2p.recurring == 'M') ? _c('div', [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "recurring"
    },
    domProps: {
      "value": _vm.form2c2p.recurring
    }
  }), _vm._v(" "), (_vm.form2c2p.chargeOnDate != '') ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": "charge_on_date"
    },
    domProps: {
      "value": _vm.form2c2p.chargeOnDate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form2c2p.chargeNextDate != '') ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": "charge_next_date"
    },
    domProps: {
      "value": _vm.form2c2p.chargeNextDate
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "allow_accumulate"
    },
    domProps: {
      "value": _vm.form2c2p.allowAccumulate
    }
  }), _vm._v(" "), (_vm.form2c2p.allowAccumulate == 'Y') ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": "max_accumulate_amount"
    },
    domProps: {
      "value": _vm.form2c2p.maxAccumulateAmount
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "order_prefix"
    },
    domProps: {
      "value": _vm.form2c2p.orderPrefix
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "recurring_amount"
    },
    domProps: {
      "value": _vm.form2c2p.recurringAmount
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "recurring_count"
    },
    domProps: {
      "value": _vm.form2c2p.recurringCount
    }
  }), _vm._v(" "), (_vm.form2c2p.recurringInterval > 0) ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": "recurring_interval"
    },
    domProps: {
      "value": _vm.form2c2p.recurringInterval || 0
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "user_defined_1"
    },
    domProps: {
      "value": _vm.form2c2p.userDefined1 || ''
    }
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hash_value"
    },
    domProps: {
      "value": _vm.form2c2p.hash_value
    }
  })]), _vm._v(" "), _c('form', {
    ref: "formTMB",
    attrs: {
      "action": _vm.formTMB.paymentUrl,
      "method": "POST"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderRef"
    },
    domProps: {
      "value": _vm.formTMB.orderRef
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "amount"
    },
    domProps: {
      "value": _vm.formTMB.amount.toFixed(2)
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currCode"
    },
    domProps: {
      "value": _vm.formTMB.currCode
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "merchantId"
    },
    domProps: {
      "value": _vm.formTMB.merchantId
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cancelUrl"
    },
    domProps: {
      "value": _vm.formTMB.cancelUrl
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "failUrl"
    },
    domProps: {
      "value": _vm.formTMB.failUrl
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "successUrl"
    },
    domProps: {
      "value": _vm.formTMB.successUrl
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "payType"
    },
    domProps: {
      "value": _vm.formTMB.payType
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "payMethod"
    },
    domProps: {
      "value": _vm.formTMB.payMethod
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lang"
    },
    domProps: {
      "value": _vm.formTMB.lang
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "remark"
    },
    domProps: {
      "value": _vm.formTMB.remark
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderRef1"
    },
    domProps: {
      "value": _vm.formTMB.orderRef1
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderRef2"
    },
    domProps: {
      "value": _vm.formTMB.orderRef2
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderRef3"
    },
    domProps: {
      "value": _vm.formTMB.orderRef3
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderRef4"
    },
    domProps: {
      "value": _vm.formTMB.orderRef4
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderRef5"
    },
    domProps: {
      "value": _vm.formTMB.orderRef5
    }
  }), _vm._v(" "), (_vm.$store.state.donateType === 'monthly') ? [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "appId"
    },
    domProps: {
      "value": _vm.formTMB.appId
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "nSch"
    },
    domProps: {
      "value": _vm.formTMB.nSch
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "schType"
    },
    domProps: {
      "value": _vm.formTMB.schType
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "sDay"
    },
    domProps: {
      "value": _vm.formTMB.sDay
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "sMonth"
    },
    domProps: {
      "value": _vm.formTMB.sMonth
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "sYear"
    },
    domProps: {
      "value": _vm.formTMB.sYear
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "eDay"
    },
    domProps: {
      "value": _vm.formTMB.eDay
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "eMonth"
    },
    domProps: {
      "value": _vm.formTMB.eMonth
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "eYear"
    },
    domProps: {
      "value": _vm.formTMB.eYear
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "name"
    },
    domProps: {
      "value": _vm.formTMB.name
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "email"
    },
    domProps: {
      "value": _vm.formTMB.email
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "schStatus"
    },
    domProps: {
      "value": _vm.formTMB.schStatus
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "remark"
    },
    domProps: {
      "value": _vm.formTMB.remark
    }
  })] : _vm._e()], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("เงื่อนไขและนโยบายการชำระเงิน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("การทำรายการบริจาคบนเว็บไซต์ "), _c('a', {
    attrs: {
      "href": "https://donate.eef.or.th"
    }
  }, [_vm._v("donate.eef.or.th")])]), _vm._v(" "), _c('ol', {
    staticClass: "content-md"
  }, [_c('li', [_vm._v("เว็บไซต์ "), _c('a', {
    attrs: {
      "href": "https://donate.eef.or.th"
    }
  }, [_vm._v("donate.eef.or.th")]), _vm._v(" จะไม่ได้เก็บข้อมูลบัตรเครดิต หรือบัตรเดบิต ตามมาตรฐานความปลอดภัยสากล ยกเว้นวันหมดอายุ และเลข 4 หลักสุดท้ายของหมายเลขบัตรเครดิต เพื่อใช้เป็นข้อมูลอ้างอิงการทำรายการ")]), _c('li', [_vm._v("เว็บไซต์ใช้บริการช่องทางการชำระเงิน (Payment Gateway) ของ TMB ซึ่งเป็นผู้ให้บริการที่ได้รับมาตรฐานความปลอดภัยในการชำระเงินออนไลน์ผ่านบัตรเครดิตและบัตรเดบิต")]), _c('li', [_vm._v("ข้อมูลส่วนตัวของผู้บริจาคหรือสมาชิก จะถูกเก็บรักษาภายใต้ความปลอดภัยของระบบ และสามารถใช้ข้อมูลเพื่อติดต่อไปยังผู้บริจาคหรือสมาชิกได้ ภายใต้จุดประสงค์ที่เกี่ยวข้องกับการดำเนินงานของกองทุนเพื่อความเสมอภาคทางการศึกษา")]), _c('li', [_vm._v("ยินยอมให้ กองทุนเพื่อความเสมอภาคทางการศึกษา เก็บ รวบรวม ใช้ ข้อมูลส่วนบุคคล เพื่อการวิจัย ติดตาม และพัฒนาการแนวทางการรับบริจาค เพื่อบรรลุวัตถุประสงค์ในลดความเหลื่อมล้ำสร้างความเสมอภาคทางการศึกษา")]), _c('li', [_vm._v("หากผู้บริจาคมีความประสงค์จะยกเลิกรายการชำระเงินใดๆ สามารถติดต่อฝ่ายข้อมูลผู้สนับสนุนของ กองทุนเพื่อความเสมอภาคทางการศึกษา ได้ที่ หมายเลขโทรศัพท์ 02-079-5475 (วันจันทร์ - ศุกร์ ติดต่อในเวลาราชการ)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form__item form__item--inline"
  }, [_c('input', {
    staticClass: "form__input",
    attrs: {
      "type": "checkbox",
      "name": "accept",
      "id": "accept"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label -font-light text-dark",
    attrs: {
      "for": "accept"
    }
  }, [_vm._v("ยินดีรับข้อมูลข่าวสารจาก กสศ. ทางอีเมล")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block--icon-bank"
  }, [_c('img', {
    staticClass: "img-fluid",
    staticStyle: {
      "max-height": "60px"
    },
    attrs: {
      "src": "/static/img/icons/ic-banking-new.png",
      "srcset": "/static/img/icons/ic-banking-new.png 1x, /static/img/icons/ic-banking-new@2x.png 2x",
      "alt": "Mobile Banking"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block--icon-bank"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/ic-line_pay.png",
      "srcset": "/static/img/icons/ic-line_pay.png 1x, /static/img/icons/ic-line_pay@2x.png 2x",
      "alt": "Rabbit LINE Pay",
      "height": "22"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "block--icon-bank"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/tesco-lotus_logo.png",
      "srcset": "/static/img/icons/tesco-lotus_logo.png 1x, /static/img/icons/tesco-lotus_logo@2x.png 2x",
      "alt": "Tesco Lotus",
      "height": "22"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/icons/big-c_logo.png",
      "srcset": "/static/img/icons/big-c_logo.png 1x, /static/img/icons/big-c_logo@2x.png 2x",
      "alt": "Big C",
      "height": "22"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/icons/paypost_logo1.png",
      "srcset": "/static/img/icons/paypost_logo1.png 1x, /static/img/icons/paypost_logo1@2x.png 2x",
      "alt": "PayPost",
      "height": "22"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/icons/mpay-station_logo.png",
      "srcset": "/static/img/icons/mpay-station_logo.png 1x, /static/img/icons/mpay-station_logo@2x.png 2x",
      "alt": "M Pay",
      "height": "22"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/icons/tw_logo.png",
      "srcset": "/static/img/icons/tw_logo.png 1x, /static/img/icons/tw_logo@2x.png 2x",
      "alt": "true money",
      "height": "22"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/icons/cenpay_logo.png",
      "srcset": "/static/img/icons/cenpay_logo.png 1x, /static/img/icons/cenpay_logo@2x.png 2x",
      "alt": "Cen Pay",
      "height": "22"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/icons/boonterm_logo.png",
      "srcset": "/static/img/icons/boonterm_logo.png 1x, /static/img/icons/boonterm_logo@2x.png 2x",
      "alt": "บุญเติม",
      "height": "22"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "d-none"
  }, [_c('br'), _vm._v("ไม่ต้องใส่เว้นวรรคหรือขีดกลาง")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "d-none"
  }, [_c('br'), _vm._v("ไม่ต้องใส่เว้นวรรคหรือขีดกลาง")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d761ee6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Payment.vue
// module id = 691
// module chunks = 1